import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { PaymentCreateForm, PaymentFormValues } from './PaymentCreateForm'
export * from './fragments'

export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmitCreatePayment: (values: PaymentFormValues) => Promise<void>
}

export const PaymentCreateTemplate: Template<State, Action> = ({
  state,
  onSubmitCreatePayment,
}) => {
  const { t } = useTranslation('paymentCreate')
  const { routerNames, routerPages } = useRouter()
  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.PaymentDetail,
      }}
    >
      <Head title={routerNames.PaymentMethodSetting} />
      <PaymentCreateForm onSubmitCreatePayment={onSubmitCreatePayment} />
    </BaseLayout>
  )
}
